import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';

export default function Modal({ open, onClose, title, children, footer, size = 'md' }) {
  const mouseDownRef = useRef(null);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  // Close only when both mousedown AND mouseup originate on the backdrop.
  // Without this, dragging to select text inside the modal fires a click on
  // the backdrop (mousedown = modal content, mouseup = backdrop → browser
  // synthesises a click on the backdrop element).
  const handleMouseDown = (e) => { mouseDownRef.current = e.target; };
  const handleMouseUp   = (e) => {
    if (e.target === e.currentTarget && mouseDownRef.current === e.currentTarget) {
      onClose();
    }
  };

  if (!open) return null;
  const maxW = { sm: 440, md: 600, lg: 820, xl: 1040 }[size] ?? 600;

  return (
    <div
      className="modal-overlay"
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
    >
      <div className="modal" style={{ maxWidth: `min(${maxW}px, calc(100vw - 32px))` }}>
        {/* Drag-handle pill — visible only on mobile bottom-sheet */}
        <div className="modal-drag-handle" aria-hidden="true" />

        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button
            className="btn btn-ghost btn-icon modal-close-btn"
            onClick={onClose}
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </div>

        <div className="modal-body">{children}</div>

        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
}
